export default class BrokerModel {
  constructor(data) {
    this.id = data.id || null;
    this.name = data.name || null;
    this.active = data.active || null;
    this.count_twice = data.count_twice || null;
    this.contact_name = data.contact_name || null;
    this.contact_skype = data.contact_skype || null;
    this.support_email = data.support_email || null;
    this.min_deposit = data.min_deposit || null;
    this.avg_cpa = data.avg_cpa || null;
    this.regulated = data.regulated || null;
    this.start_date = data.start_date || null;
    this.orders_amount = data.orders_amount || null;
    this.created_at = data.created_at || null;
    this.updated_at = data.updated_at || null;
  }
}
